<template>
  <div class="ly-card message-send">
    <div class="lf">
      <h3>发送对象</h3>
      <ul>
        <li v-for="(item, i) in userGroup" :class="i === index - 1 && 'active'" :key="item.id" @click="clickItem(i)">
          {{ item.group_name }}
        </li>
      </ul>
    </div>
    <div class="rg" v-if="index > 0">
      <el-button type="primary" @click.native="dialogVisible = true" :disabled="!selection.length || !curTmp"
        >发送</el-button
      >
      <div class="tmp-choose">
        <span class="message-content">{{ curDetail }}</span>
      </div>
      <div class="search-hd">
        <div class="fr">
          <template v-if="searchHdLimit[index - 1][0]">
            <el-select v-model="searchFormData.year" clearable placeholder="所属学年">
              <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="searchFormData.term" clearable placeholder="所属学期">
              <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
          <ly-form :formConfig="formConfig" :formKeys="formKeys" ref="lyForm"></ly-form>
          <el-input placeholder="班级名称/班级代码" v-if="index === 1 || index === 5 || index === 6" v-model="searchFormData.class_name_or_code"></el-input>
          <el-input placeholder="学员姓名" v-if="index === 1 || index === 2" v-model="searchFormData.name"></el-input>
          <el-input placeholder="职工姓名" v-if="index === 3" v-model="searchFormData.name"></el-input>
          <el-input placeholder="用户名/姓名" v-if="index === 4" v-model="searchFormData.name"></el-input>
          <el-select v-model="searchFormData.class_week"  v-if="index === 7" clearable placeholder="星期">
              <el-option v-for="item in weeks" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          <el-button type="primary" @click.native="() => search()">查询</el-button>
        </div>
      </div>
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        :tableConfig="tableConfig"
        ref="lyTable"
      ></ly-table>
    </div>
    <el-dialog title="发送短信确认" :visible.sync="dialogVisible" width="500px">
      <h2>接收人</h2>
      <ul>
        <li v-for="item in selection" :key="item.id">{{ item.real_name }}</li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="send">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dialog, Input, Select, Option
} from 'element-ui';
import {
  message, contact, teacher
} from '@/api';
import {
  studentTable, teacherTable, staffTable, regTable, otherTable
} from '@/utils/tableHeaderMessage';
import LyTable from '@/components/LyTable';
import { specializedSearchForm } from '@/utils/formConfigCommon';
import LyForm from '@/components/LyForm';

const specializedSearchFormTmp = window.cloneDeep(specializedSearchForm);

delete specializedSearchFormTmp.fee_level_id;
specializedSearchFormTmp.org_id.label = '';
specializedSearchFormTmp.specialized_subject_id_parent.label = '';
specializedSearchFormTmp.specialized_subject_id.label = '';

export default {
  name: 'MessageSend',
  components: {
    ElDialog: Dialog,
    LyTable,
    ElSelect: Select,
    ElInput: Input,
    ElOption: Option,
    LyForm
  },
  data() {
    return {
      formConfig: {},
      template_name: '',
      index: 1,
      dialogVisible: false,
      curTmp: '',
      getTableData: contact.getStudent,
      searchFormData: {
        is_reserved: true,
        group_code: '',
        name: '',
        org_id: '',
        year: '',
        term: '',
        interview_audit_status: '',
        specialized_subject_id: '',
        rocking_number_status: '',
        class_week: '',
        class_name_or_code: ''
      },
      selection: [],
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      tableHeaders: [studentTable, teacherTable, staffTable, regTable, otherTable, otherTable, otherTable],
      tableHeader: [],
      userGroup: [],
      curDetail: '',
      years: [],
      terms: [],
      curForm: 0, // 0(不需要form) 1(只需要部门) 3 or 其他(需要部门和项目)
      searchHdLimit: [
        [1, 0],
        [0, 3],
        [0, 1],
        [1, 0],
        [1, 0],
        [1, 0],
        [1, 3]
      ], // 权限顺序 学年学期/部门项目
      weeks: Object.freeze([
        {
          label: '周日',
          value: '0'
        },
        {
          label: '周一',
          value: '1'
        },
        {
          label: '周二',
          value: '2'
        },
        {
          label: '周三',
          value: '3'
        },
        {
          label: '周四',
          value: '4'
        },
        {
          label: '周五',
          value: '5'
        },
        {
          label: '周六',
          value: '6'
        }
      ])
    };
  },
  computed: {
    formKeys() {
      const tmp = { ...specializedSearchFormTmp };
      if (!this.curForm) return {};
      if (this.curForm === 1) {
        delete tmp.specialized_subject_id_parent;
        delete tmp.specialized_subject_id;
        return tmp;
      }
      return tmp;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      message.smsUserGroup().then(res => {
        // 用户分组
        if (res && res.data) {
          this.userGroup = res.data.user_group_list;
          this.search();
        }
      });
      this.$store.dispatch('schoolYear/getTermAndYearList').then(list => {
        if (list) {
          this.years = list.year;
          this.terms = list.term;
        }
      });
    },
    async getDetail(id) {
      const res = await message.querSmsTemplateDetail({ id });
      if (res && res.data) {
        this.curDetail = res.data.sms_template_detail.content;
      }
    },
    changeItem(value) {
      this.getDetail(value);
    },
    clickItem(index) {
      this.searchFormData.name = '';
      this.index = index + 1;
      this.search();
      [, this.curForm] = this.searchHdLimit[index];
    },
    search(data) {
      this.tableHeader = this.tableHeaders[this.index - 1];
      this.searchFormData = {
        ...this.searchFormData,
        ...this.userGroup[this.index - 1],
        ...data
      };
      if (this.index === 1) this.getTableData = contact.getStudent;
      else if (this.index === 2) this.getTableData = teacher.getTeachers;
      else this.getTableData = message.groupDetail;
      this.$nextTick(() => {
        this.$refs.lyTable.setData();
      });
    },
    send() {
      message
        .sendMessage({
          params: {
            template_id: this.curTmp,
            group_id: this.userGroup[this.index - 1].id,
            user_id_list: this.selection.map(item => item.id)
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '短信正在发送！');
            this.search();
            this.dialogVisible = false;
          }
        });
    }
  }
};
</script>
<style lang="less">
.message-send {
  display: flex;
  height: calc(100vh - @navBarTopHeight - @navBarTagsHeight - 10px);
  overflow: auto;
  .message-content {
    margin-left: 10px;
  }
  .lf {
    width: 220px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #ccc;
    overflow: auto;
    position: relative;
    padding-bottom: 40px;
    padding-right: 10px;
    h3 {
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .btn-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      text-align: center;
    }
    ul {
      padding-left: 10px;
      li {
        list-style: none;
        display: flex;
        cursor: pointer;
        font-size: 15px;
        padding: 10px 5px;
        align-items: center;
        border-bottom: 1px solid #ccc;
        &.active {
          background: #409eff;
          color: #fff;
          border-color: #409eff;
        }
      }
    }
  }
  .rg {
    flex: 1;
    margin-left: 10px;
    max-width: calc(100% - 230px);
    .fr {
      >* {
        margin-top: 10px;
      }
    }
    .tmp-choose {
      border-bottom: 1px solid #ccc;
      padding: 20px 0;
      margin-bottom: 10px;
    }
    .search-hd {
      border-bottom: 1px solid #ccc;
      overflow: hidden;
      margin-top: 20px;
      padding-bottom: 20px;
      .el-input {
        width: 160px;
        margin-right: 10px;
      }
    }
  }
  .ly-form {
    display: inline-block;
    vertical-align: top;
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
